import CountryService from "app/services/CountryService";

export const teamMemberCountryLabel = (code: string | null | undefined): string => {
    if (!code) {
        return "";
    }
    return CountryService.getCountryByCode(code)?.text ?? code;
};
